module.exports = __webpack_public_path__ + "static/media/gen-02.a069e7d4.png";